<template>
  <div class="wl-results" v-if="doc">
    <results-bar-multiple
      :doc="doc"
      @loadSummary="loadSummary"
      @loadBoard="loadBoard"
      :tiles="tiles"
      :boards="boards"
    ></results-bar-multiple>
    <results-summary
      v-if="summary"
      :id="doc.id"
      :summaryMode="summaryMode"
      :model="model"
      :tiles="tiles"
      :localTiles="tiles"
      :key="model"
    ></results-summary>
    <results-board
      v-if="!summary"
      :id="currentId"
      :model="model"
      :localTitles="tiles"
    ></results-board>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  ResultsSummary,
  ResultsBoard,
  ResultsBarMultiple,
} from "@/components/results/tiles";
const fb = require("@/firebaseConfig.js");

export default {
  name: "ResultTiles",
  props: {
    doc: {
      type: Object,
      default: null,
    },
    model: String,
  },
  data() {
    return {
      summary: true,
      summaryMode: "collated",
      currentId: null,
      userList: null,
      tiles: [],
    };
  },
  computed: {
    ...mapState(["exTiles"]),
  },
  components: {
    ResultsSummary,
    ResultsBoard,
    ResultsBarMultiple,
  },
  mounted() {
    this.getExercise();
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.summary = true;
    },
    loadBoard(id) {
      this.currentId = id;
      this.summary = false;
    },
    getExercise() {
      let ref = fb[this.model].where("pid", "==", this.doc.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          let users = [];
          let boards = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            users.push(post.uid);
            boards.push(post);
            post.selectedTiles.forEach((img) => {
              items.push(img);
            });
          });
          if (items) {
            this.tiles = items;
          }
          if (boards) {
            this.boards = boards;
          }
          if (users) {
            this.userList = users;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
